export const Event = {
  MaximizerIdentityReady: 'maximizer_identity_ready',
  PageView: 'page-view',
} as const;

export enum EventAction {
  Cancelled = 'cancelled',
  Clicked = 'clicked',
  Closed = 'closed',
  Completed = 'completed',
  Executed = 'executed',
  Failed = 'failed',
  Opened = 'opened',
  Refreshed = 'refreshed',
  Saved = 'saved',
  Started = 'started',
  Submitted = 'submitted',
}

export enum EventModule {
  AiTimelineSummary = 'ai-timeline-summary',
  IqBoost = 'iq-boost',
  Appointment = 'appointment',
  Case = 'case',
  Compose = 'compose',
  Contact = 'contact',
  Email = 'email',
  Entry = 'entry',
  EntryDetails = 'entry-details',
  Menu = 'menu',
  Notification = 'notification',
  Onboarding = 'onboarding',
  Opportunity = 'opportunity',
  Outlook = 'outlook',
  Preferences = 'preferences',
  Received = 'received',
  Related = 'related',
  RelatedDetail = 'related-detail',
  RelatedRecords = 'related-records',
}

export enum EventJourney {
  Action = 'action',
  AddRecipient = 'add-recipient',
  AskQuestion = 'ask-question',
  AutoSaveToggle = 'auto-save-toggle',
  Chat = 'chat',
  CopyToClipboard = 'copy-to-clipboard',
  Create = 'create',
  DraftEmail = 'draft-email',
  EditEntry = 'edit-entry',
  Exit = 'exit',
  Feedback = 'feedback',
  Finished = 'finished',
  Loading = 'loading',
  MoveRecipient = 'move-recipient',
  Open = 'open',
  QuestionLibrary = 'question-library',
  RemindLater = 'remind-later',
  Repeat = 'repeat',
  Save = 'save',
  SaveNote = 'save-note',
  SaveNow = 'save-now',
  SaveToAll = 'save-to-all',
  Search = 'search',
  SearchDetails = 'search-details',
  SecurityCenter = 'security-center',
  ShareEntry = 'share-entry',
  ShowMore = 'show-more',
  Started = 'started',
  Step = 'step',
  StatusMessage = 'status-message',
  SuggestedQuestion = 'suggested-question',
  Summarize = 'summarize',
  Summary = 'summary',
  Tab = 'tab',
  Update = 'update',
  UpdatePreferences = 'update-preferences',
  UserSuggestion = 'user-suggestion',
  ViewInMaximizer = 'view-in-maximizer',
}

export enum EventMetadata {
  Failed = 'failed',
  Incoming = 'incoming',
  Negative = 'negative',
  Outgoing = 'outgoing',
  Positive = 'positive',
  Success = 'success',
  Calendar = 'calendar',
  Mail = 'mail',
  Required = 'required',
  Optional = 'optional',
  On = 'on',
  Off = 'off',
  RequiredToOptional = 'required-to-optional',
  OptionalToRequired = 'optional-to-required',
}
